import React, { useEffect, useState } from "react"
import Value from "aldoo-ra/Value"

const platformMapping = {
  ios: "ios",
  android: "android",
  windows: "windows",
  linux: "android", // Maps linux to windows in the site platform
  mac: "ios",
  unknown: "android",
}

const SitePlatform = () => {
  const [detected_platform] = Value("detected_platform")
  const [platform, setPlatform] = useState("")

  useEffect(() => {
    // Set the platform based on the detected platform
    const resolved = platformMapping[detected_platform]
    setPlatform(resolved ?? platformMapping["unknown"])
  }, [detected_platform])

  return {
    platform,
  }
}

export default SitePlatform
